import styled from "styled-components";

export const $DirectFeedbackFormContainer = styled.div`
  max-width: 350px;
  text-align: left;
  margin: 30px auto auto;
`;
